import React from 'react';
import { Button, Form, Input, Row, Col, Select, Checkbox } from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
import { observer, inject } from 'mobx-react';
import { formItemLayout } from '../../const/FormConst';

@inject('otaStore')
@observer
class OTAFormComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillUnmount() {
    this.props.form.resetFields();
  }
  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.props.otaStore.searchOta(
          value.deviceId,
          value.current,
          value.target
        );
        this.props.otaStore.page_num = 1;
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { targetVersion, currentVersion } = this.props.otaStore;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col span={6}>
            <FormItem {...formItemLayout} label="设备编号">
              {getFieldDecorator('deviceId', {
                rules: [{ pattern: /^[0-9A-F,]*$/, message: '请输入0~9,A~F!' }]
              })(<Input placeholder="请输入设备编号" />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem {...formItemLayout} label="当前版本">
              {getFieldDecorator('current')(
                <Select placeholder="请选择当前版本">
                  {(targetVersion || []).map(item => (
                    <Option value={item} key={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem {...formItemLayout} label="目标版本">
              {getFieldDecorator('target')(
                <Select placeholder="请选择目标版本">
                  {(currentVersion || []).map(item => (
                    <Option value={item} key={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={2} offset={2}>
            <Button type="primary" onClick={this.handleSubmit}>
              {' '}
              搜索
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
const OTAForm = Form.create()(OTAFormComponent);
export default OTAForm;



// WEBPACK FOOTER //
// ./src/components/OTA/OTAForm.js